import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
import ImageViewer from '../../content_viewer/viewers/image_viewer.vue';
import { diffModes, imageViewMode } from '../constants';
import OnionSkinViewer from './image_diff/onion_skin_viewer.vue';
import SwipeViewer from './image_diff/swipe_viewer.vue';
import TwoUpViewer from './image_diff/two_up_viewer.vue';
export default {
    name: 'ImageDiffViewer',
    components: {
        ImageViewer
    },
    mixins: [
        glSlotsMixin
    ],
    props: {
        diffMode: {
            type: String,
            required: true
        },
        newPath: {
            type: String,
            required: false,
            default: null
        },
        oldPath: {
            type: String,
            required: false,
            default: null
        },
        newSize: {
            type: Number,
            required: false,
            default: 0
        },
        oldSize: {
            type: Number,
            required: false,
            default: 0
        },
        encodePath: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    data () {
        return {
            mode: imageViewMode.twoup
        };
    },
    computed: {
        imageViewComponent () {
            switch(this.mode){
                case imageViewMode.twoup:
                    return TwoUpViewer;
                case imageViewMode.swipe:
                    return SwipeViewer;
                case imageViewMode.onion:
                    return OnionSkinViewer;
                default:
                    return undefined;
            }
        },
        isNew () {
            return this.diffMode === diffModes.new;
        },
        isRenamed () {
            return this.diffMode === diffModes.renamed;
        },
        imagePath () {
            return this.isNew || this.isRenamed ? this.newPath : this.oldPath;
        }
    },
    methods: {
        changeMode (newMode) {
            this.mode = newMode;
        }
    },
    diffModes,
    imageViewMode
};
